import { Stack } from '@optimus-web/core';
import { UseSortedLoyaltyMembershipsParams, useSortedLoyaltyMemberships } from './useSortedLoyaltyMemberships';
import { LoyaltyMembershipTag } from './LoyaltyMembershipTag';

type LoyaltyMembershipTagListProps = UseSortedLoyaltyMembershipsParams;

export const LoyaltyMembershipTagList = ({ loyaltyMemberships }: LoyaltyMembershipTagListProps) => {
    const loyaltyMembershipItems = useSortedLoyaltyMemberships({ loyaltyMemberships });

    return (
        <Stack spacing="100" itemAlignment="start" vertical>
            {loyaltyMembershipItems.map((item) => (
                <LoyaltyMembershipTag key={item.id} {...item} markPrimary />
            ))}
        </Stack>
    );
};
